/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useContext } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

import {
  GlobalStateContext,
} from "../context/GlobalContextProvider"

const Layout = ({ children }) => {
  const state = useContext(GlobalStateContext)

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <div className={`theme-${state.theme} bg-background-primary text-copy-primary`}>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div
          style={{
            margin: `0 auto`,
            maxWidth: 1000,
            padding: `0px 1.0875rem 1.45rem`,
            paddingTop: 0,
          }}
        >
        <main className="mainLayout">{children}</main>
        </div>
        <footer className="text-center text-white text-sm h-10 align-middle" style={{ backgroundColor: `#333`, lineHeight: `2.5rem`}}>
          © {new Date().getFullYear()} Konstantinos Papadopoulos
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
